import { createFileRoute, useParams } from "@tanstack/react-router";
import { createRecordAttachmentsListQueryOptions } from "@/features/attachments/adapters/record-attachments-adapter";
import { RecordAttachmentsWorkspace } from "@/features/attachments/components/record-attachments-workspace";
import { ATTACHMENTS_FILES_PAGE_SIZE } from "@/features/attachments/types";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/records/$recordId/workspace/attachments",
)({
	loader: ({ context, params }) =>
		context.queryClient.ensureQueryData(
			createRecordAttachmentsListQueryOptions({
				recordId: params.recordId,
				organizationId: params.orgId,
				start: 1,
				count: ATTACHMENTS_FILES_PAGE_SIZE,
			}),
		),
	component: RecordWorkspaceAttachmentsTab,
});

/**
 * Record workspace Attachments tab — thin route adapter.
 */
function RecordWorkspaceAttachmentsTab() {
	const params = useParams({
		from: "/_authenticated/(web-app)/_web/web/$orgId/jobs/(job)/$jobId/workspace/records/$recordId/workspace/attachments",
	});

	return (
		<RecordAttachmentsWorkspace
			orgId={params.orgId}
			recordId={params.recordId}
		/>
	);
}
